import { render, staticRenderFns } from "./dimensionList.vue?vue&type=template&id=5a5de08c&scoped=true"
import script from "./dimensionList.vue?vue&type=script&lang=js"
export * from "./dimensionList.vue?vue&type=script&lang=js"
import style0 from "./dimensionList.vue?vue&type=style&index=0&id=5a5de08c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5de08c",
  null
  
)

export default component.exports